import { Tilelet } from "@vds/tiles";
import { Title, Body } from '@vds/typography';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useGetDevicesAndPlansByNameQuery } from '../../features/devicesAndPlans/devicesAndPlansFetch';
import { GetFooterNotes, GetHelperText, GetPlanPageDetails, GetSelectedDeviceDetails } from "../../shared/components/GetPlanPageDetails.jsx";
import { useSelector } from 'react-redux';
import { getDestList } from '../../shared/utils/globalUtils';
import FullPageLoader from '../../shared/components/Loader';
import { isDesktop, unauth, SessionIdGlobal } from '../../shared/utils/globalConfig';
import inflightDesktop from '../../assets/images/inflight_desktop.png'
import inflightMobile from '../../assets/images/inflight_mobile.png';
import inflightTablet from '../../assets/images/inflight_tablet.png';
import ReviewModal from '../../pages/ITP/ReviewModal';
import { dispatchPageView } from '../../shared/utils/tagging';
import { saveSelectedDeviceDetails, saveSelectedDestinations } from '../../features/selectedData/selectedDataReducer';
import {saveConfirmedPlanData, savePersistantDestinations, savePersistantDates, setSessionIdVarUnauth, saveSelectedDeviceDetailsUnauth } from '../../features/selectedData/persistantDataReducer';
import {getDevicesPayload } from '../../shared/utils/globalUtils';
import xss from 'xss';

const CruisePlanSelectionMain = styled.div`
`
const Space = styled.div`
padding-top: ${props => props.pt || 24}px;
`
const fetchValues = (sessionIdVarUnauth) => {
    if(unauth){
    return( (sessionIdVarUnauth === SessionIdGlobal)? false : true)}
       
   }
export default function CruisePlanSelection() {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { selectedDestinations, selectedDates,selectedDeviceDetailsUnauth, onlyCruise, sessionIdVarUnauth } = useSelector(state => state?.persistantReducer);
    
    const { selectedDeviceDetails } = useSelector(state => state?.selectedReducer);
    let isSesIdNotMatched =  false;
       isSesIdNotMatched = fetchValues(sessionIdVarUnauth);
       useEffect(() => {
           if (isSesIdNotMatched && unauth) {
            dispatch(setSessionIdVarUnauth(""));
               dispatch(saveConfirmedPlanData([]));
               dispatch(savePersistantDestinations([]));
               dispatch(savePersistantDates({}));
               dispatch(saveSelectedDestinations([]));
               dispatch(saveSelectedDeviceDetailsUnauth({}));
               
               window.location.href = xss('/digital/nsa/nos/ui/intl/trip/');
           }
       }, [])

    const getsDevicesPayloadUnauth = () => {
        let payload = {
            'destinationSelected': getDestList(selectedDestinations, 'key'),
            "travelStartDate": selectedDates?.travelStartDate,
            "travelEndDate": selectedDates?.travelEndDate,
            "unAuthflow": true,
            "deviceNickName": selectedDeviceDetailsUnauth?.deviceDisplayName,
            "deviceImageUrl": selectedDeviceDetailsUnauth?.deviceImageUrl,
            "skuId": selectedDeviceDetailsUnauth?.skuId,
            "brandName": selectedDeviceDetailsUnauth?.brandName,
        }
        return payload;
    }
    
    const Payload = unauth ? getsDevicesPayloadUnauth() : getDevicesPayload(selectedDates, selectedDestinations);
    const { data, isLoading,} = useGetDevicesAndPlansByNameQuery(Payload,{ skip: unauth && (Object.keys(selectedDeviceDetailsUnauth).length == 0 || selectedDestinations?.length === 0 || isSesIdNotMatched)})

    const [planPageDetails, setPlanDetails] = useState();
    const [showReviewModal, setReviewModal] = useState(false);

    useEffect(() => {
        setPlanDetails(data?.body?.data?.planDetailsSea)

    }, [data]);
    //Redirect to destination, if destination and travel dates are empty
    useEffect(() => {

         let isEmptyRedirect =  Object.keys(unauth ? selectedDeviceDetailsUnauth : selectedDeviceDetails)?.length === 0 ;
         let isDestinationEmpty = selectedDestinations?.length === 0 || (selectedDates?.travelStartDate == undefined && selectedDates?.travelEndDate == undefined);
   
        if ((!onlyCruise && isEmptyRedirect) || isDestinationEmpty) {
                if (unauth) {
                window.location.href = xss('/digital/nsa/nos/ui/intl/trip/');
            }
            else {
                window.location.href = xss('/digital/nsa/secure/ui/intl/trip/');
            } 
        }
    }, [unauth ? selectedDeviceDetailsUnauth : selectedDeviceDetails])

     //saveSelectedDeviceDetails from planpage response for unauth flow
     useEffect(() => {
        if(unauth && onlyCruise) 
           {
            dispatch(saveSelectedDeviceDetails(data?.body?.data?.devicesAndPlans?.deviceDetails[0])); 
           } 
    }, [data]);


        //Tagging
    useEffect(() => {
        dispatchPageView('ITP_CruisePlanSelection','cruise plan selection','#cruise_selection');
    },[])

    const getSeaPlans = () => {
        let plans = [];
        let criuseplans = planPageDetails?.cruisePlanInfo.map((plan) => {
            if (plan?.planTypeName === 'CRUISE_DAILY_PASS' && selectedDeviceDetails.cruisePlan) {
                let cruisePlanUpdated = JSON.parse(JSON.stringify(plan))
                cruisePlanUpdated['currentPlan'] = selectedDeviceDetails?.currentPlanAsCruise;
                plans.push(cruisePlanUpdated);
            }
            if (plan?.planTypeName === 'PAYGO_SEA' && selectedDeviceDetails.payAsYouGoSea) {
                let payAsYouGoSeaUpdated = JSON.parse(JSON.stringify(plan))
                payAsYouGoSeaUpdated['currentPlan'] = selectedDeviceDetails?.currentPlanAsPaygoSea;
                plans.push(payAsYouGoSeaUpdated);
            }
        })
        return plans;
    }
    const onTileClick = () => {
        setReviewModal(true);
    }

    return (
        <CruisePlanSelectionMain id="cruise_selection">
            {(!isLoading && planPageDetails)
                ?
                <>
                    <GetSelectedDeviceDetails planType="sea"/>
                    <Space />
                    <Title size="XLarge">{planPageDetails?.cruisePageTitle}</Title>
                    <Space />
                    <Body size="large">{planPageDetails?.cruisePageHeading}</Body>
                    {planPageDetails?.discountedCustomer && <><Space /><Body size="large">{planPageDetails?.discountedPlans}</Body></>}
                    <GetPlanPageDetails availablePlans={getSeaPlans()} theme='monarch' planType={'sea'} />
                    <GetHelperText subHeadingText={planPageDetails?.subHeadingText} />
                    <Space pt={32}></Space>
                    {selectedDeviceDetails?.inflightPlan && <><Title size="Xlarge " bold >{planPageDetails?.inflightDataObject?.alsoAvailableText}</Title>
                        <Space ></Space>
                        <Tilelet
                            title={{
                                size: 'titleMedium',
                                children: planPageDetails?.inflightDataObject?.planName,
                                primitive: 'h1',
                            }}
                            subtitle={{
                                size: 'bodyLarge',
                                children: planPageDetails?.inflightDataObject?.planDesc,
                                primitive: 'h1',

                            }}
                            directionalIcon={{
                                name: 'right-arrow',
                                size: 'medium',
                            }}
                            surface='light'
                            width={isDesktop ? '45%' : '100%'}
                            height={isDesktop ? '300px' : '185px'}
                            onClick={() => { onTileClick() }}
                            showBorder={true}
                            backgroundColor='black'
                            backgroundImage={planPageDetails?.inflightDataObject?.planImageUrl} />
                    </>}<Space pt={32}></Space>
                    <GetFooterNotes footerNotes={planPageDetails?.cruiseFooterNotes} />

                    {showReviewModal &&
                        <ReviewModal
                            setReviewModal={setReviewModal}
                            showReviewModal={showReviewModal}
                            PlanData={data?.body?.data?.inFlightReviewDetailObject}
                        />
                    }
                </>
                :
                <FullPageLoader></FullPageLoader>}
        </CruisePlanSelectionMain>

    );
} 